/** Only variants published for the app can select an app menu. */
export const isAppMenuVariant = (
  variant: { targetPlatforms?: ReadonlyArray<string | null> | null } | null | undefined
): boolean => variant?.targetPlatforms?.includes('app') === true;
